import { memo } from 'react';
import PropTypes from 'prop-types';
import * as styles from './styles/styles.module.scss';
import { MapStatsUtil } from '../../utils/map_stats_util';
import { translateRouteType } from '../../utils/trail_helpers';
import LanguageRegionCode from '@alltrails/shared/types/LanguageRegionCode';
import { FormattedMessage } from '@alltrails/shared/react-intl';

const TrailStats = ({ trail, routeType, displayMetric, languageRegionCode }) => {
  return (
    <section className={styles.trailStatSection}>
      <div>
        <span className={styles.trailStatIcons}>
          <span className={styles.statsLabel}>
            <FormattedMessage defaultMessage="Length" />
          </span>
          <span className={styles.detailData}>{MapStatsUtil.metersToFormattedUserUnits(trail.length, 1, displayMetric, languageRegionCode)}</span>
        </span>
        <span className={styles.trailStatIcons}>
          <span className={styles.statsLabel}>
            <FormattedMessage defaultMessage="Elevation gain" />
          </span>
          <span className={styles.detailData}>{MapStatsUtil.elevationFormatted(trail.elevation_gain, displayMetric, languageRegionCode)}</span>
        </span>
        <span className={styles.trailStatIcons}>
          <span className={styles.statsLabel}>
            <FormattedMessage defaultMessage="Route type" />
          </span>
          <span className={styles.detailData}>{translateRouteType(routeType)}</span>
        </span>
      </div>
    </section>
  );
};

TrailStats.propTypes = {
  trail: PropTypes.object.isRequired,
  routeType: PropTypes.string,
  displayMetric: PropTypes.bool,
  languageRegionCode: PropTypes.string
};

TrailStats.defaultProps = {
  displayMetric: false,
  routeType: '',
  languageRegionCode: LanguageRegionCode.English
};

export default memo(TrailStats);
